import './style.scss'

import React, { lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'

import { ButtonColor } from '~/components/buttons/buttonColor'
import { userSelector } from '~/store/userSlice'

import ArrowIcon from '../../assets/icons/arrow.svg?react'
import { useSectionMapVisibility } from './use-section-map-visibility'

const SectionMapContent = lazy(() => import('./SectionMapContent')
    .then((module) => ({ default: module.SectionMapContent })))

function SectionMapPlaceholder() {
    const user = useSelector(userSelector)

    return (
        <section id="anchor-map" className="section-map section-map--placeholder">
            <div className="section-map__container">
                <div className="section-map__content">
                    <div className="section-map__subtitle">/ Live · WTA Map</div>
                    <div className="section-map__info">
                        <div className="section-map__top">
                            <h2 className="section-map__title">Book Capacity Before It Flies Empty</h2>
                            <div className="section-map__text">Operators publish flights with cargo capacity available to book.</div>
                            <div className="section-map__list-routes">
                                <a className="section-map__card-button" href={user?.id ? '/empty-legs' : '/public-empty-legs'}>
                                    <ButtonColor text="Browse cargo aircraft empty legs" SvgIcon={ArrowIcon} />
                                </a>
                            </div>
                        </div>
                        <div className="section-map__map" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export function SectionMap() {
    const { ref, isVisible } = useSectionMapVisibility()

    return (
        <div ref={ref}>
            {isVisible ? (
                <Suspense fallback={<SectionMapPlaceholder />}>
                    <SectionMapContent />
                </Suspense>
            ) : <SectionMapPlaceholder />}
        </div>
    )
}
